export default __webpack_public_path__ + "static/2c7c47885a073f8a7ca8cdbf9af704b2.jpeg";